import request from "@/core/services/request";

export function testService(data) {
  return request({
    url: "/api/v1/test/service/",
    method: "post",
    data: data,
  });
}
